<template>
	<div class="o-dashboard">
		<c-loader-container :loading="loading">
			<template v-if="!loading">
		        <c-table
		            class="c-table--request c-table--request-progress"
		            :columns="columns"
		            :filters="filters"
					:placeholder="'Zoeken op naam en/of kenmerk'"
		            :endpoint="'/api/invoices/list/'"
		            :key="'table-in-progress'"
					@load="applied"></c-table>
			</template>
		</c-loader-container>
	</div>
</template>

<script>
import CTable from '@components/table/Container';
import CLoaderContainer from '@components/loader/Container';
import CTabs from '@components/tab/Container';
import CTab from '@components/tab/Element';

import CRequest from '@app/modals/Request';
import View from '@mixins/View';

export default {
	components: { CTable, CTabs, CTab, CRequest, CLoaderContainer },
	mixins: [ View ],
	data() {
		return {
			translators: [],
			loading: true
		}
	},
	methods: {
		applied(params) {
			this.$store.dispatch('user/addDeclarationFilter', params);
		}
	},
	computed: {
		columns() {

			let columns = [
				{ name: 'klaar_at', label: 'Datum', component: 'CColumnDatetime', sortable: true, sort: true },
				{ name: 'aanvrager', label: 'Aanvrager', sortable: true },
				{ name: 'opdrachtnemer_naam', label: 'Tolk/Vertaler', sortable: true },
				{ name: 'kenmerk', label: 'Kenmerk', sortable: true },
				//{ name: 'taak', label: 'Taak' },
				{ name: 'brontaal', label: 'Brontaal' },
				{ name: 'doeltaal', label: 'Doeltaal' },
				{ name: 'aantal', label: 'Woorden/Gespreksduur' },
				{ name: 'service', label: 'Type dienst' },
				{ name: 'tarief', label: 'Uur- en of woordtarief', component: 'CColumnCents' },
				{ name: 'totaal_tarief', label: 'Bedrag', component: 'CColumnCents' },
			];

			return columns;
		},
		filters() {

			let sortFn = (a,b) => (a.label > b.label) ? 1 : (a.label === b.label) ? 0 : -1;

			let applicants = [];

			this.preferences.clients.forEach( (c) => {
				applicants.push({ label: c.user.name, value: c.id });
			});

			applicants.sort(sortFn);

			let translators = [];

			this.translators.forEach( (c) => {
				translators.push({ label: c.user.name, value: c.id });
			});

			translators.sort(sortFn);

			let filters = [
				{
					name: 'aanvrager',
					placeholder: 'Alle aanvragers',
					options: applicants
				},
				{
					name: 'opdrachtnemer',
					placeholder: 'Alle opdrachtnemers',
					options: translators
				},
				{
					name: 'periode',
					placeholder: 'Periode',
					options: [
						{value: 'vandaag', label: 'Vandaag'},
						{value: 'gisteren', label: 'Gisteren'},
						{value: 'deze week', label: 'Deze week'},
						{value: 'vorige week', label: 'Vorige week'},
						{value: 'deze maand', label: 'Deze maand', preselected: true },
						{value: 'vorige maand', label: 'Vorige maand'},
						{value: 'dit jaar', label: 'Dit jaar'},
						{value: 'vorig jaar', label: 'Vorig jaar'}
					]
				}
			];

			return filters;
		}
	},
	mounted() {
		this.$xhr.post('/api/translators/all/').then( ( {result}) => {
			this.translators = result;
			this.loading = false;
		}).catch( (e) =>{
			console.log(e);
		});
	}
}
</script>
